import { Box } from '@react-three/drei'

export default function BedMesh({ width, height, depth, position, color, isSelected }) {
    // 寝台: 高さの60%（上部）
    const mattressHeight = height * 0.6
    const mattressY = position[1] + height / 2 - mattressHeight / 2

    // 脚: 4本の短い柱
    const legWidth = width * 0.08
    const legDepth = depth * 0.08
    const legHeight = height * 0.4
    const legY = position[1] - height / 2 + legHeight / 2

    const legPositions = [
        [0 - width / 2 + legWidth / 2, legY, 0 - depth / 2 + legDepth / 2], // 左手前
        [0 + width / 2 - legWidth / 2, legY, 0 - depth / 2 + legDepth / 2], // 右手前
        [0 - width / 2 + legWidth / 2, legY, 0 + depth / 2 - legDepth / 2], // 左奥
        [0 + width / 2 - legWidth / 2, legY, 0 + depth / 2 - legDepth / 2], // 右奥
    ]

    return (
        <group>
            {/* 寝台 */}
            <Box args={[width, mattressHeight, depth]} position={[0, mattressY, 0]}>
                <meshStandardMaterial
                    color={color}
                    metalness={0.3}
                    roughness={0.4}
                    opacity={isSelected ? 1 : 0.9}
                    transparent
                />
            </Box>

            {/* 脚 */}
            {legPositions.map((legPos, index) => (
                <Box key={index} args={[legWidth, legHeight, legDepth]} position={legPos}>
                    <meshStandardMaterial
                        color={color}
                        metalness={0.3}
                        roughness={0.4}
                        opacity={isSelected ? 1 : 0.9}
                        transparent
                    />
                </Box>
            ))}

            {/* ワイヤーフレーム - 寝台 */}
            <Box args={[width, mattressHeight, depth]} position={[0, mattressY, 0]}>
                <meshBasicMaterial
                    color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'}
                    wireframe
                    opacity={isSelected ? 0.6 : 0.3}
                    transparent
                />
            </Box>

            {/* ワイヤーフレーム - 脚 */}
            {legPositions.map((legPos, index) => (
                <Box key={`wire-${index}`} args={[legWidth, legHeight, legDepth]} position={legPos}>
                    <meshBasicMaterial
                        color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'}
                        wireframe
                        opacity={isSelected ? 0.6 : 0.3}
                        transparent
                    />
                </Box>
            ))}

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
